import React from 'react';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FillProfileImage from '../../Components/ImagesWithElements/FillProfileImage';
import styled from 'styled-components';
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';

const Styles = styled.div`
    .progress {
    position: absolute;
    width: 34%;
    height: 6px;
    left: 0px;
    top: 0px;
    background: #2196F3
}
`

export const FillProfileEmployer1 = ({isCompanyExist = false}) => {

    const navigate = useNavigate();

    const {addInformationManager, getManagerInformation} = usePortalService();

    const [lastName, setLastName] = useState('');
    const [lastNameDirty, setLastNameDirty] = useState(false);
    const [lastNameError, setLastNameError] = useState('Введите фамилию');

    const [firstName, setFirstName] = useState('');
    const [firstNameDirty, setFirstNameDirty] = useState(false);
    const [firstNameError, setFirstNameError] = useState('Введите имя');

    const [patronymic, setPatronymic] = useState('');

    const [post, setPost] = useState('');
    const [postDirty, setPostDirty] = useState(false);
    const [postError, setPostError] = useState('Введите должность');

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'lastName':
                setLastNameDirty(true)
                break;
            case 'firstName':
                setFirstNameDirty(true)
                break;
            case 'post':
                setPostDirty(true)
                break;
        }
    }

    const lastNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(e.target.value)
        if (e.target.value.length == 0) {
            setLastNameError('Фамилия не может быть пустой')
        } else if (e.target.value.length < 2) {
            setLastNameError('Фамилия не может состоять из одного символа')
        } else {
            setLastNameError('')
        }
    }

    const firstNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(e.target.value)
        if (e.target.value.length == 0) {
            setFirstNameError('Имя не может быть пустым')
        } else if (e.target.value.length < 2) {
            setFirstNameError('Имя не может состоять из одного символа')
        } else {
            setFirstNameError('')
        }
    }

    const patronymicHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPatronymic(e.target.value)
    }

    const postHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPost(e.target.value)
        if (e.target.value.length == 0) {
            setPostError('Должность не может быть пустой')
        } else if (e.target.value.length < 2) {
            setPostError('Должность не может состоять из одного символа')
        } else {
            setPostError('')
        }
    }

    useEffect(() => {
        getManagerInformation().then(result => {
            setFirstName(result.manager.firstName);
            setFirstNameError('');
            setLastName(result.manager.lastName);
            setLastNameError('');
            setPatronymic(result.manager.patronymic);
            setPost(result.manager.position);
        });
    }, []);

    const handleContinue = async (e: React.FormEvent) => {
        e.preventDefault();
        if (lastNameError || firstNameError || postError) {
            setLastNameDirty(true)
            setFirstNameDirty(true)
            setPostDirty(true)
        } else {
            const result = await addInformationManager({
                lastName,
                firstName,
                patronymic,
                position: post
            });
    
            if (result.success) {
                handleNextPage();
            }
        }
    }

    const handleNextPage = () => {
        if (isCompanyExist) {
            navigate("/")
        } else {
            navigate("/fillProfile2")
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <FillProfileImage firstName={firstName}/>
                </section>
                <div className="content" >
                    <div className="auth-content">
                        {(!isCompanyExist) && <p className="step">Шаг 1 из 3</p>}
                        <h1 style={{ marginBottom: '32px', marginTop: isCompanyExist ? '30px' : '0px'}}> Расскажите подробнее о себе </h1>
                        <Form>
                            <Form.Group className="form-group" controlId="formLastName">
                                <Form.Label> Фамилия </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='lastName'
                                    value={lastName} 
                                    onBlur={blurHandler} 
                                    onChange={lastNameHandler}
                                    isInvalid={!!(lastNameDirty && lastNameError)} 
                                />
                                {(lastNameDirty && lastNameError) && <p className="error-alert">{lastNameError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formFirstName">
                                <Form.Label> Имя </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='firstName'
                                    value={firstName} 
                                    onBlur={blurHandler} 
                                    onChange={firstNameHandler}
                                    isInvalid={!!(firstNameDirty && firstNameError)}
                                />
                                {(firstNameDirty && firstNameError) && <p className="error-alert">{firstNameError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formPatronymic">
                                <Form.Label> Отчество </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='patronymic'
                                    value={patronymic} 
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => patronymicHandler(e)}
                                />
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formPost">
                                <Form.Label> Должность </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='post'
                                    value={post} 
                                    onBlur={blurHandler} 
                                    onChange={postHandler}
                                    isInvalid={!!(postDirty && postError)} 
                                />
                                {(postDirty && postError) && <p className="error-alert">{postError}</p>}
                            </Form.Group>
                            <br />
                            <Button type="primary" onClick={handleContinue}> {isCompanyExist ? "Подтвердить" : "Продолжить"} </Button>
                            <Button type="text" onClick={handleNextPage}> {isCompanyExist ? "Пропустить, заполню позже" : "Пропустить"} </Button>
                        </Form>
                    </div>
                </div>
            </div>
            {(!isCompanyExist) && <Styles>
                <div className="progress"></div>
            </Styles>}
        </>
    );
};